<template>
  <v-flex>
    <template v-if="customerName && binId">
      <v-flex pa-2 v-show="!productQueryParams.categoryId">
        <v-flex style="height: calc(100vh - 262px); overflow-y: auto">
          <v-layout row wrap>
            <v-flex
              xs6
              sm4
              md3
              v-for="(category, index) in categoryList"
              :key="index"
              class="d-flex flex-column"
            >
              <v-card
                color="primary"
                class="white--text px-3 py-3 flex-grow-1 d-flex align-center"
                @click="onSearch(category)"
                style="cursor: pointer"
              >
                <div class="card-name">{{ category.name }}</div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex
        v-show="productQueryParams.categoryId"
        style="max-height: 100vh; overflow-y: auto; overflow-x: hidden"
      >
        <v-flex mb-2>
          <v-btn @click="backToCategory" flat small class="mx-0">
            <v-icon left>arrow_back</v-icon> Category </v-btn
          >/ <strong>{{ productQueryParams.category }}</strong>
        </v-flex>

        <v-flex class="product-items-container">
          <div class="text-xs-center">
            <span v-if="!showListLoading && productList.length == 0">
              No data
            </span>

            <template v-if="showListLoading">
              <span>Loading</span>

              <v-progress-linear
                height="4"
                :indeterminate="true"
                v-if="showListLoading"
              ></v-progress-linear>
            </template>
          </div>
          <v-layout row wrap v-if="!showListLoading && productList.length">
            <v-flex
              class="xs6 sm6 md4 lg3"
              v-for="product in productList"
              :key="`pro-${product.id}`"
            >
              <v-card
                class="elevation-1 mx-auto"
                :title="product.name"
                @click="onSelect(product)"
                style="
                  border: 1px solid grey;
                  border-radius: 4px;
                  cursor: pointer;
                  height: 94px;
                "
              >
                <v-img
                  v-if="product.imageUrl"
                  :aspect-ratio="16 / 9"
                  :src="product.imageUrl"
                  height="150px"
                  width="150px"
                ></v-img>
                <v-card-title class="px-2 pb-0 pt-2">
                  <span class="grey--text">{{ product.code }}</span>
                </v-card-title>
                <v-card-text class="px-2 pt-0 pb-2">
                  <div class="card-name">
                    {{ product.name }}
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <div class="text-xs-center">
          <v-pagination
            v-model="pagination.page"
            :length="pagination.totalPages"
            :total-visible="4"
          ></v-pagination>
        </div>
      </v-flex>
    </template>
    <template v-else-if="!customerName">
      <v-flex style="height: calc(100vh - 246px)">
        <div class="text-xs-center mt-3">-</div>
      </v-flex>
    </template>
    <template v-else-if="!binId">
      <v-flex style="height: calc(100vh-246px)">
        <div class="text-xs-center mt-3">Please select the bin.</div>
      </v-flex>
    </template>
    <template v-else>
      <v-flex style="height: calc(100vh - 246px)">
        <div class="text-xs-center mt-3">
          Items are imported from the selected order and can be added as FOC
          items.
        </div>
      </v-flex>
    </template>
  </v-flex>
</template>

<script>
import axios from "axios";
import { categoryService } from "../../services/category-service";
import { productService } from "../../services/product-service";

export default {
  props: ["queryParams", "orderNo", "isFOC", "customerName", "binId"],
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    productList: [],
    categoryList: [],
    productQueryParams: {
      status: "ACTIVE",
      categoryId: "",
      category: "",
      warehouseId: "",
      binIds: "",
      pricemodelId: "",
      isSale: true,
    },
    rowsPerPageItems: [16, 32],
    pagination: {
      page: 1,
      rowsPerPage: 16,
      sortBy: "createdDate",
      totalItems: 0,
      totalPages: 0,
    },
    showListLoading: false,
    totalRows: 0,
    categoryPanel: null,
    cancelTokenSource: null,
  }),
  watch: {
    pagination: {
      handler() {
        if (this.productQueryParams.categoryId) this.onSearch();
      },
      deep: true,
    },
    queryParams: {
      handler() {
        this.productQueryParams = Object.assign(
          this.productQueryParams,
          this.queryParams
        );

        this.onSearch();
      },
      deep: true,
    },
    binId: {
      handler() {
        this.backToCategory();
        this.productQueryParams.binIds = [this.binId];
      },
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.status) {
      this.productQueryParams.status = this.$route.query.status;
    }
    if (this.$route.query.barcode) {
      this.productQueryParams.barcode = this.$route.query.barcode;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.$route.query.warehouseId) {
      this.productQueryParams.warehouseId = this.$route.query.warehouseId;
    } else {
      this.productQueryParams.warehouseId = this.user.shop.warehouse.id;
    }

    this.productQueryParams.pricemodelId = "";

    if (this.$route.query.categoryId) {
      this.productQueryParams.categoryId = this.$route.query.categoryId;
      this.productQueryParams.category = this.$route.query.category;

      this.onSearch({
        id: this.productQueryParams.categoryId,
        name: this.productQueryParams.category,
      });
    }

    this.getCategoriesByStatus();
  },
  methods: {
    onSearch(category) {
      if (category) {
        this.productQueryParams.categoryId = category.id;
        this.productQueryParams.category = category.name;

        this.pagination.page = 1;
        this.pagination.rowsPerPage = 8;
      }
      this.$router.replace({
        name: "whole-sale-detail",
        query: this.productQueryParams,
      });
      //        .catch(() => {});

      this.getProductList();
    },
    async getCategoriesByStatus() {
      try {
        const res = await categoryService.getCategoriesByStatus("ACTIVE", true);
        this.categoryList = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async getProductList() {
      this.cancelTokenSource = axios.CancelToken.source();

      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";

      try {
        const res = await productService.getProductList(
          this.productQueryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy ? this.pagination.sortBy + "," + order : "",
          this.cancelTokenSource.token
        );
        if (res.data) {
          this.productList = res.data.productList;
          this.totalRows = res.data.totalElements;
          this.pagination.totalPages = res.data.totalPages;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.showListLoading = false;
      }
    },
    onSelect(item) {
      this.$emit("select", item);
    },
    backToCategory() {
      this.productQueryParams.categoryId = null;
      this.productQueryParams.category = null;

      if (
        this.cancelTokenSource &&
        typeof this.cancelTokenSource.cancel == "function"
      )
        this.cancelTokenSource.cancel(
          "Operation canceled by clicking back to category"
        );

      this.$router.replace({
        name: "whole-sale-detail",
        query: this.productQueryParams,
      });
      //        .catch(() => {});

      this.productList = [];
    },
  },
};
</script>

<style>
.card-name {
  font-size: 13px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.product-items-container {
  height: calc(100vh - 364px);
  margin-bottom: 12px !important;
  overflow-y: auto;
}
</style>
